/**
 * Primary / outline buttons styled with Tailwind.
 */
export default function Button({
  children,
  type = "button",
  variant = "outline",
  className = "",
  disabled = false,
  ...rest
}) {
  const base =
    "inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/80 disabled:cursor-not-allowed disabled:opacity-50";
  const variants = {
    outline:
      "border border-white/25 bg-transparent text-white hover:border-white/40 hover:bg-white/5",
    solid:
      "border border-sky-500/80 bg-sky-600 text-white hover:bg-sky-500",
    ghost: "border border-transparent text-white hover:bg-white/10",
  };

  return (
    <button
      type={type}
      disabled={disabled}
      className={`${base} ${variants[variant] || variants.outline} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
